﻿const Enums = {
    AmountPercent: {
        Amount: 0,
        Percent: 1,
    },
    AlertLevelMap: {
        0: "information",
        1: "warning",
        2: "alert"
    }
};

export default Enums;
